import { ComponentDoctorProps } from '@/types/components';
import Image from 'next/image';

export function Doctor(props: ComponentDoctorProps) {
  const { name, image, role } = props;

  const styles = {
    container: 'space-y-3',
    imageContainer: 'relative aspect-square',
    image: 'rounded-2xl md:rounded-4xl object-cover',
    name: 'sh-body space-y-5',
    role: 'sh-body',
  };
  return (
    <article data-test='doctor' className={styles.container}>
      <div className={styles.imageContainer}>
        <Image
          src={image?.url ?? ''}
          alt={image?.alt ?? ''}
          fill
          className={styles.image}
          sizes='400px'
        />
      </div>
      <header>
        <h1 className={styles.name}>
          {name}
          {role && ', '}
        </h1>
        <h2 className={styles.role}>{role}</h2>
      </header>
    </article>
  );
}
